export const ensurePair = (v: any): [number, number] => {
  if (Array.isArray(v) && v.length >= 2) {
    return [Number(v[0]) || 0, Number(v[1]) || 0];
  }
  if (typeof v === "string" && v.includes(":")) {
    const [a, b] = v.split(":");
    return [Number(a) || 0, Number(b) || 0];
  }
  return [0, 0];
};

export const extractFirstNonZero = (
  parts: string[],
  keys: string[]
): [number, number] | null => {
  for (const k of keys) {
    const needle = `${k}=`;
    const hit = parts.find((p) => p.trim().startsWith(needle));
    if (hit) {
      const raw = hit.slice(needle.length).trim();
      const pair = ensurePair(raw);

      return pair;
    }
  }
  return null;
};

// GPP=H_GOALS / H_ATT : A_GOALS / A_ATT
// Örn: "GPP=0 / 2:0 / 1"
const safePct = (num: number, den: number) => {
  if (!den || den <= 0) return 0;
  return (num / den) * 100;
};

export const parseGPP = (
  parts: string[]
): {
  home: { goals: number; attempts: number };
  away: { goals: number; attempts: number };
  efficiency: { home: number; away: number };
} | null => {
  const key = parts.find(
    (p) =>
      p.trim().startsWith("GPP=") ||
      p.trim().startsWith("PPG/ATT=") ||
      p.trim().startsWith("POWER PLAY=")
  );
  if (!key) return null;

  // "GPP=0 / 2:0 / 1" -> ["0 / 2", "0 / 1"]
  const raw = key.split("=")[1]?.trim();
  if (!raw) return null;

  const sides = raw.split(":");
  if (sides.length < 2) return null;

  const parseSide = (s: string): { goals: number; attempts: number } => {
    // "0 / 2"
    const [g, a] = s.split("/").map((t) => t.trim());
    return {
      goals: Number(g) || 0,
      attempts: Number(a) || 0,
    };
  };

  const home = parseSide(sides[0]);
  const away = parseSide(sides[1]);

  return {
    home,
    away,
    efficiency: {
      home: safePct(home.goals, home.attempts),
      away: safePct(away.goals, away.attempts),
    },
  };
};
